<template>
	<div class="w-100">
		<div id="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
						<div class="box">
				            <DateRange
				                :start.sync="start_date"
				                :end.sync="end_date"
				                @submit="loadTracking"
				            />

				            <CustomTable
				                id_table="delete_storage_tracking"
				                :items="trackings"
				                :busy.sync="table_busy"
				                primaryKey="sdt_id"
				                :hide_if_empty="true"
				            />
      					</div>
      				</div>
        		</div>
        	</div>
        </div>
	</div>
</template>

<script type="text/javascript">
import User from "@/mixins/User.js";

export default {
	name: 'DeleteStorageTracking',
    mixins: [User],
	data () {
		return {
            start_date: new Date(new Date().setMonth(new Date().getMonth() - 1)),
			end_date: new Date(new Date().setMonth(new Date().getMonth())),
            trackings: [],
            table_busy: false
		}
	},

	mounted() {
		this.init_component()
	},

	methods: {
		async init_component() {
			this.loadTracking()
        },

        async loadTracking() {
			this.table_busy = true
			this.trackings = await this.getTrackingsDeleteStorage(this.start_date.toDateInputValue(), this.end_date.toDateInputValue());
			this.table_busy = false
        },
	},

	components: {
		HeaderTab: () => import('@/components/HeaderTab'),
		CustomTable : () => import('GroomyRoot/components/Table/CustomTable'),
        DateRange: () => import('GroomyRoot/components/Inputs/DateRange'),
	}
}

</script>